

































































import { Component, Vue } from "vue-property-decorator"
import { mapState } from "vuex"
import BookingReadCandidate from "./BookingReadCandidate.vue"
import BookingReadBookingCandidateFormFields from "./BookingReadBookingCandidateFormFields.vue"

@Component({
  components: {
    BookingReadCandidate,
    BookingReadBookingCandidateFormFields,
  },
  computed: {
    ...mapState("Booking", {
      booking: "booking",
    }),
  },
})
export default class BookingReadCandidateInformation extends Vue {
  // Booking State
  booking!: Booking

  search = ""
  showSheet = false
  selectedBookingCandidate = null
  selectedBookingCandidateIndex = 0

  headers = [
    {
      text: "Candidate",
      value: "candidate",
    },
    {
      text: "Share Code",
      value: "share_code",
    },
    {
      text: "Quescreen Status",
      value: "status",
    },
    {
      text: "Additional Services",
      value: "additional_services",
    },
    {
      text: "Actions",
      value: "actions",
      sortable: false,
    },
  ]

  get bookingCandidates() {
    return this.booking.booking_candidates || []
  }

  filterCandidate(value, search, item) {
    return Object.keys(item).some((k) => {
      return (
        [
          "first_name",
          "last_name",
          "date_of_birth",
          "mobile",
          "email",
        ].includes(k) && item[k].toString().toLowerCase().includes(search)
      )
    })
  }

  editBookingCandidate(bookingCandidate, index) {
    this.showSheet = true
    this.selectedBookingCandidate = bookingCandidate
    this.selectedBookingCandidateIndex = index
  }
}
